export type TenantId = 'maluwilz' | 'plcc'

export type Locale = 'de' | 'en'

export interface TenantLegalLinks {
  terms?: string
  privacy: string
  imprint: string
}

export interface TenantOidc {
  /* Zitadel instance issuer, e.g. https://login.maluwilz.de */
  authority: string
  /* Public OIDC client id (SPA/PKCE, not a secret). Empty until the tenant's
     Zitadel instance + app exist - login is disabled while empty. */
  clientId: string
}

export interface Tenant {
  id: TenantId
  name: string
  defaultLocale: Locale
  supportedLocales: Locale[]
  /* Official public website (NOT the portal). Linked from the footer brand. */
  officialUrl: string
  /* External destination for the download area (opens in a new tab). Empty
     falls back to the internal placeholder page. */
  downloadUrl: string
  /* External destination for the dealer-news page (opens in a new tab). Empty
     hides the news tile (no destination yet). */
  newsUrl: string
  legal: TenantLegalLinks
  oidc: TenantOidc
  features: {
    styleguide: boolean
    /* The portal shop (new order form). Off = ComingSoon placeholder, so an
       unfinished shop never blocks a portal go-live. */
    shop: boolean
  }
}

/* Static, typed tenant definitions. Which hostname maps to which tenant is
   environment config (runtime config tenantHosts), not code - but what a
   tenant IS belongs here, typed and reviewable. Brand values live in
   src/styles/themes.css under [data-tenant]. */
export const tenants: Record<TenantId, Tenant> = {
  maluwilz: {
    id: 'maluwilz',
    name: 'MALU WILZ Beauté',
    defaultLocale: 'de',
    supportedLocales: ['de', 'en'],
    officialUrl: 'https://www.maluwilz.de',
    downloadUrl: 'https://maluwilz.de/de-de/pages/download-bereich',
    newsUrl: 'https://maluwilz.de/de-de/pages/handler-news',
    legal: {
      terms: 'https://www.maluwilz.de/de-de/pages/agb-b2b',
      privacy: 'https://maluwilz.de/de-de/policies/privacy-policy',
      imprint: 'https://maluwilz.de/de-de/policies/legal-notice',
    },
    oidc: {
      authority: 'https://login.maluwilz.de',
      clientId: '384667613160079364',
    },
    features: {
      /* Styleguide is dev documentation only - hidden in nav and blocked by the
         route guard. The page and route stay in the code (reachable in dev). */
      styleguide: false,
      shop: true,
    },
  },
  /* Future tenant (partner.plcc-gmbh.de) - not mapped to any host yet.
     Brand: plcc-gmbh.de (gold #caa35b, Helvetica Neue), see themes.css. */
  plcc: {
    id: 'plcc',
    name: 'PLCC Private Label Cosmetic Company',
    defaultLocale: 'de',
    supportedLocales: ['de', 'en'],
    officialUrl: 'https://plcc-gmbh.de',
    downloadUrl: '',
    newsUrl: '',
    legal: {
      privacy: 'https://plcc-gmbh.de/datenschutz/',
      imprint: 'https://plcc-gmbh.de/impressum/',
    },
    oidc: {
      authority: 'https://login.plcc-gmbh.de',
      clientId: '384756614328025092',
    },
    features: {
      /* Styleguide is dev documentation only - hidden in nav and blocked by the
         route guard. The page and route stay in the code (reachable in dev). */
      styleguide: false,
      shop: false,
    },
  },
}
